import { randomKey } from '@portabletext/block-tools';

const whiteListedScripts = [
  'https://fast.wistia.com/',
  '//fast.wistia.com/',
  'https://fast.wistia.net/',
  '//fast.wistia.net/',
  'https://player.vimeo.com/api/player.js',
  '//www.instagram.com/embed.js',
  'https://platform.twitter.com/widgets.js',
  'https://cdn.logwork.com/widget/countdown.js',
  'https://www.instagram.com/',
  '//www.instagram.com/',
  'https://www.youtube.com/',
  '//www.youtube.com/',
  'https://www.facebook.com/',
  '//www.facebook.com/',
  'https://apis.google.com/',
  '//apis.google.com/',
];

const scriptObjFromScriptElement = (script: HTMLScriptElement) => {
  return {
    type: script.type || 'text/javascript',
    src: script.src,
    innerHTML: script.innerHTML,
    async: script.async || false,
    'embed-id': script.getAttribute('embed-id'),
  };
};

export const extractScriptsFromDoc = (doc: Document) => {
  const docScriptTags = doc.querySelectorAll('script') || [];
  return Array.from(docScriptTags).map((script) => {
    const clonedScript = script.cloneNode(true) as HTMLScriptElement;
    clonedScript.setAttribute('embed-id', randomKey(16));
    return clonedScript;
  });
};

export const addScriptTagToHead = (script: HTMLScriptElement) => {
  if (!script.src) return;
  if (!whiteListedScripts.some((whitelist) => script.src.startsWith(whitelist))) return;
  useHead({
    script: [scriptObjFromScriptElement(script)],
  });
};

export const removeScriptTagFromHead = (script: HTMLScriptElement) => {
  const targetScript = document.head.querySelector(
    `script[embed-id="${script.getAttribute('embed-id')}"]`
  );
  if (!targetScript) {
    return;
  }
  targetScript.remove();
};
